(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name crewValidation.controller:CrewValidationCtrl
	 *
	 * @description
	 *
	 */
	angular
		.module('crewValidation')
		.directive('focusOn',function($timeout) {
    		return {
    			restrict : 'A',
    			link : function(vm,$element,$attr) {
    				vm.$watch($attr.focusOn,function(_focusVal) {
    					$timeout(function() {
    						_focusVal ? $element[0].focus() :
    							$element[0].blur();
                    	});
                	});
            	}
    		}
    	})
		.controller('CrewValidationCtrl',CrewValidationCtrl);

	function CrewValidationCtrl(CommonMasterData, crewScheduleService,
			CrewValidationService, MessageService, applicationConstants,
			PopupManager, EventManagerService) {
		var vm = this;
		vm.ctrlName = 'CrewValidationCtrl';

		vm.model = {
			searchPanelToggle : true,
			initialSearchDone : false,
			searchCriteria : {},
			editorMode : applicationConstants.EDITOR_STATUS.ADD,
			masterList : {
				crewTypes : [],
				crewDetails : [],
				validationTypes : [],
				validations : [],
				aircraftTypes : [],
				crewBaseList : [],
				countries : [],
				showMandatoryValidation : false,
				showValidationTypeValidation : false,
				isCountrySelectionRequired : false,
				isEditable : true,
				isDateEditable : true,
				enableSave : true,
        isDeleted:true,
        isNewJoiner: false,
        disableSaveforTraning: false
			},
			crewValidations : [],// grid data
			validationReqObj : {},
			acTypeByValidationReq : {},
			selectedValidation : CrewValidationService.getNewValidation()
		};

		// to hide and show search panel
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// to hide and show new Alert panel
		vm.clickOnNew = function() {
			addNewValidation();
		};

		// when change field in search
		vm.changeSearchField = function(searchParams, flag) {
			if (flag === 'crewType') {
				vm.model.masterList.crewDetails = loadCrewList(searchParams.crewType);
				vm.model.masterList.validations = loadValidaitonList(searchParams);
				if (!!searchParams.crewType
						&& vm.model.searchCriteria.crew != undefined) {
					vm.model.searchCriteria.crew = undefined;
				}
			} else if (flag === 'validationType') {
				vm.model.masterList.validations = loadValidaitonList(searchParams);
				if (!!searchParams.validationType
						&& vm.model.searchCriteria.validation != undefined) {
					vm.model.searchCriteria.validation = undefined;
				}
			} else if (flag === 'crewName') {
				vm.model.searchCriteria.crewId = searchParams.crew.crewId;
				vm.model.masterList.validations = loadValidaitonList(searchParams);
			} else if (flag === 'crewId') {
				vm.model.masterList.validations = loadValidaitonList(searchParams);
			}
		};

		// get crew List by crew Type Code
		function loadCrewList(crewType) {
			var param = {};
			param.crewType = '';
			param.active = true;
			// only if crew Type code is available
			if (!!crewType) {
				param.crewType = crewType.crewTypeCode;
				CommonMasterData.loadCrewList(param, function(response) {
					vm.model.masterList.crewDetails = crewScheduleService
							.adaptCrewList(response);
				}, function() {
					console.log('Crew list retrieval error');
				});
			} else {
				vm.model.masterList.crewDetails = [];
			}
		}

		// get validations by validation type
		function loadValidaitonList(searchParams) {

			// only if validations Type code is available
			if (!!searchParams.validationType) {
				vm.model.validationReqObj = CrewValidationService
						.setValidationRequest(searchParams);
				CommonMasterData.loadValidationList(vm.model.validationReqObj,
						function(response) {
							vm.model.masterList.validations = response;
						}, function() {
							console.log('Validation List retrieval error');
						});
			} else {
				vm.model.masterList.validations = [];
			}
		};

		// set acTypes by validation
		function setACTypesByValidation(selectedValidation) {
			// only if validations Type code is available
			if (!!selectedValidation.validation) {
				vm.model.acTypeByValidationReq = CrewValidationService
						.setACTypeByValidationRequest(selectedValidation);
				CommonMasterData.loadACTypesByValidationList(vm.model.acTypeByValidationReq,
						function(response) {
							if(!!response.aircrafts && response.aircrafts.length>0){
								vm.model.selectedValidation.acType = _.find(vm.model.masterList.aircraftTypes, {
									modelNumber : response.aircrafts[0].modelNumber
								});
							}else{
								vm.model.selectedValidation.acType = null
							}
						}, function() {
							console.log('AC Type List by Validation retrieval error');
						});
			}
		};

		// submit search and set search results
		vm.submitSearchCrewValidation = function(params) {
			if (params == undefined
					|| ((params.crewType == undefined || params.crewType == null)
							&& (params.crewId == undefined || params.crewId == null || params.crewId == ""))) {
				vm.model.masterList.showMandatoryValidation = true;
				vm.model.masterList.showValidationTypeValidation = false;
			} else if (params.crewType != undefined
					&& (params.crewId == undefined || params.crewId == null || params.crewId == "")
					&& (params.validation == undefined || params.validation == null)) {
				vm.model.masterList.showMandatoryValidation = false;
				vm.model.masterList.showValidationTypeValidation = true;
			} else {
				vm.model.masterList.showMandatoryValidation = false;
				vm.model.masterList.showValidationTypeValidation = false;
				vm.model.initialSearchDone = false;
				vm.model.searchCriteria = params;
				CrewValidationService
						.setCrewValidationSearchRequest(vm.model.searchCriteria);
				getCrewValidations();
			}
		};

		// get validation list
		function getCrewValidations() {
			CrewValidationService.searchCrewValidations(
					function(validationList) {
						vm.model.crewValidations = validationList;
						vm.model.searchPanelToggle = false;
						vm.model.initialSearchDone = true;
					}, function(error) {
						MessageService.error(error);
					});
		}
		;

		function clearSearchFeildAndDependancyList() {
			vm.model.searchCriteria = {};
			vm.model.masterList.validations = [];
			vm.model.masterList.crewDetails = [];
		}
		;

		// clear fields and dependency lists
		function clearEditFeildAndDependancyList() {
			vm.model.editorMode = applicationConstants.EDITOR_STATUS.ADD;
			vm.model.selectedValidation = CrewValidationService.getNewValidation();
			vm.model.masterList.validations = [];
			vm.model.masterList.crewDetails = [];
			vm.model.masterList.isCountrySelectionRequired = false;
			vm.model.masterList.isEditable = true;
			vm.model.masterList.isDateEditable = true;
		}
		;

		// when grid row is selected
		vm.selectACrewValidationRow = function(selectedRowData) {
			vm.model.searchPanelToggle = false;
      vm.model.masterList.isNewJoiner = (selectedRowData.isNewJoinCrew =='Y') ? true: false;
			vm.model.editorMode = applicationConstants.EDITOR_STATUS.EDIT
			vm.model.selectedValidation = CrewValidationService
					.setSelectedValidation(selectedRowData);
			if (selectedRowData.isAllowToEdit == 'N'){
			  vm.model.masterList.isDeleted = false ;
        vm.model.masterList.isEditable = false;
      }else{
        vm.model.masterList.isDeleted = true;
        vm.model.masterList.isEditable = true;
      }
			showHideCountrySelection();
			enableOrDisableEditPanal();
		};

		// enable or disable editor panel by validation type
		function enableOrDisableEditPanal() {
			if (!!vm.model.selectedValidation.validationType
					&& vm.model.selectedValidation.validationType.isAllowToEditDate == 'N') {
				vm.model.masterList.isDateEditable = false;
			} else {
				vm.model.masterList.isDateEditable = true;
			}
		}

		// show hide country selection in edit panel
		function showHideCountrySelection() {
			if (!!vm.model.selectedValidation.validationType
					&& vm.model.selectedValidation.validationType.description == 'VISA') {
				vm.model.masterList.isCountrySelectionRequired = true;
			} else {
				vm.model.masterList.isCountrySelectionRequired = false ;
			}
		}

		// when click on the new validation add
		vm.addNewValidation = function() {
			vm.model.searchPanelToggle = false;
			clearEditFeildAndDependancyList();
		};

		// when editor panel field change
		vm.changeEditorField = function(selectedItem, flag) {
			if (selectedItem == undefined) {
				selectedItem = vm.model.selectedValidation;
			}
			if (flag === 'crewType') {
				vm.model.masterList.crewDetails = loadCrewList(selectedItem.crewType);
				vm.model.masterList.validations = loadValidaitonList(selectedItem);
				if (!!selectedItem.crewType
						&& vm.model.selectedValidation.crew != undefined) {
					vm.model.selectedValidation.crew = undefined;
				}
			} else if (flag === 'validationType') {
				vm.model.selectedValidation.validationCountries = [];
				vm.model.masterList.validations = loadValidaitonList(selectedItem);
				if (!!selectedItem.validationType
						&& vm.model.selectedValidation.validation != undefined) {
					vm.model.selectedValidation.validation = undefined;
					setACTypesByValidation(selectedItem);
				}
        if (!!selectedItem.validationType && selectedItem.validationType.isAllowToSave =="N"){
          vm.model.masterList.disableSaveforTraning = true;
        }else{
          vm.model.masterList.disableSaveforTraning = false;
        }
				// show hide Country selection
				showHideCountrySelection();
			} else if (flag === 'crewName') {
				vm.model.selectedValidation.crewId = selectedItem.crew.crewId;
				vm.model.masterList.validations = loadValidaitonList(selectedItem);
			} else if (flag == 'warnBefore' && !selectedItem.neverExpire) {
				setWarningDate(selectedItem);
			} else if (!selectedItem.neverExpire
					&& (flag == 'dateOfExpiry')) {
				setWarningDate(selectedItem);
			} else if (selectedItem.neverExpire && flag == 'neverExpire') {
				vm.model.selectedValidation.dateOfWarning = null;
				vm.model.selectedValidation.dateOfExpire = null;
				vm.model.selectedValidation.warningBefore = null;
			}else if(flag == 'validation'){
				setWarningDate(selectedItem);
				vm.model.selectedValidation.validationCountries = [];
				setACTypesByValidation(selectedItem);
			}
		};

		//set warning date when warning before and expire date is available
		function setWarningDate(selectedItem){

			if (!!selectedItem.dateOfExpire && selectedItem.dateOfExpire != null && selectedItem.dateOfExpire != "") {
				var dateOfExpire = convertStringDateToDate(selectedItem.dateOfExpire);
				selectedItem.warningDatePickerOption.maxDate = dateOfExpire;
				//set warning before
				if(!!!vm.model.selectedValidation.warningBefore && !!vm.model.selectedValidation.validation){
					setWarningBefore(vm.model.selectedValidation);
				}
				dateOfExpire.setDate(dateOfExpire.getDate()
						- selectedItem.warningBefore);
				vm.model.selectedValidation.dateOfWarning = dateOfExpire
						.getDate()
						+ '/'
						+ (dateOfExpire.getMonth() + 1)
						+ '/'
						+ dateOfExpire.getFullYear();
			} else {
				vm.model.selectedValidation.dateOfWarning = "";
				setWarningBefore(vm.model.selectedValidation);
			}
		}

		function setWarningBefore(selectedItem){
			if(!!selectedItem && !!selectedItem.validation && !!!vm.model.selectedValidation.warningBefore){
				vm.model.selectedValidation.warningBefore = selectedItem.validation.warningPeriod;
			}else if(!!!vm.model.selectedValidation.warningBefore){
				vm.model.selectedValidation.warningBefore =0;
			}
		};

		// convert string date to the Date object
		function convertStringDateToDate(strDate) {
			var date = "";
			if (strDate != null && strDate != undefined && strDate != "") {
				var dateString = strDate.split("/");
				date = new Date(parseInt(dateString[2]), parseInt(dateString[1]) - 1, parseInt(dateString[0]));
			}
			return date;
		}

		vm.submitCrewValidation = function(action, selectedItem) {
			vm.model.selectedValidation = selectedItem;
			//check if dates are setted
			if(!!vm.model.selectedValidation.dateOfIssue && (vm.model.selectedValidation.neverExpire ||!!vm.model.selectedValidation.dateOfExpire )){
				if (action === applicationConstants.EDITOR_STATUS.DELETE) {
					var param = {
						title : 'Confirmation',
						messages : [ "Do you want to delete this record" ],
						flags : selectedItem
					};
					PopupManager.openModal('CONFIRM_DIALOG', param,
							confirmDeleteDialog);
				} else if (action === applicationConstants.EDITOR_STATUS.ADD
						|| action === applicationConstants.EDITOR_STATUS.EDIT) {
					saveCrewValidation();
				}
			}
		};

		function confirmDeleteDialog(pass) {
			if (pass === 'YES') {
				CrewValidationService
						.deleteCrewValidation(
								vm.model.selectedValidation,
								function(response) {
									if (response.success) {
										MessageService
												.success('Crew Validation is Successfully deleted!');
										if (vm.model.initialSearchDone) {
											getCrewValidations();
										}
										clearEditFeildAndDependancyList();
									} else if (!!response.errors
											&& response.errors.length > 0) {
										MessageService
												.error(response.errors[0]);
									}
								}, function(error) {
									MessageService.error(error);
								});
			}
		}

		// save Crew Validation
		function saveCrewValidation() {
			CrewValidationService
					.saveCrewValidation(
							vm.model.selectedValidation,
							function(response) {
								if (response.overlapExist) {
									var ignoreOverlap = {};
									ignoreOverlap.title = "Confirm Overlap";
									ignoreOverlap.messages = [];
									ignoreOverlap.messages[0] = !!response.messages ? response.messages[0]
											: "Over Lap Exists";
									ignoreOverlap.messages[1] = "Do you want to ignore overlap?";
									PopupManager
											.openModal('CONFIRM_DIALOG',
													ignoreOverlap,
													handelConfirmOverlap);
								} else if (response.success) {
									MessageService
											.success('Crew Validation is Successfully saved!');
									if (vm.model.initialSearchDone) {
										getCrewValidations();
									}
									clearEditFeildAndDependancyList();

								} else if (!!response.errors
										&& response.errors.length > 0) {
									MessageService.error(response.errors[0]);
								}
							}, function(error) {
								MessageService.error(error);
							});
		}

		// handle overlap confirmation
		function handelConfirmOverlap(pass) {
			if (pass === 'YES') {
				vm.model.selectedValidation.ignorOverlap = true;
				saveCrewValidation();
			}
		}
		;

		// get master data list
		(function() {
			// crew types
			CommonMasterData.getCrewTypeList(function(crewTypes) {
				vm.model.masterList.crewTypes = crewTypes;
			}, function() {
				console.log('Crew types retrieval error');
			});
			// crew validation Types
			CommonMasterData.getValidationTypeList(function(validationTypes) {
				vm.model.masterList.validationTypes = validationTypes;
			}, function() {
				console.log('Validation Type List retrieval error');
			});
			// aircraft types
      CommonMasterData.getAircraftModels(function (airCraftList) {
        vm.model.masterList.aircraftTypes = airCraftList;
      }, function () {
        console.log('Aircraft type retrieval error');
      });
			// base list
			CommonMasterData.getCrewBaseList(function(crewBases) {
				vm.model.masterList.crewBaseList = crewBases;
			}, function() {
				console.log('Crew Base List retrieval error');
			});
			// countryList
			CommonMasterData.getCountryList(function(countries) {
				vm.model.masterList.countries = countries;
			}, function() {
				console.log('Country List retrieval error');
			});
		})();
	}
}());
